module.exports = __webpack_public_path__ + "img/F118.8aba8afd.jpg";